<template>
  <el-dialog
    :visible.sync="isVisible"
    :title="addClassTypeDialog.title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    @close="closeDialog"
  >
    <div class="form">
      <el-form
        ref="form"
        :model="form"
        :label-width="dialog.formLabelWidth"
        style="margin: 10px; width: auto"
      >
        <el-form-item required prop="classType" label="班级类型">
          <el-input
            type="text"
            placeholder="请输入班级类型"
            v-model="form.classType"
          ></el-input>
        </el-form-item>

        <el-form-item required prop="courseHours" label="课时数">
          <el-input
            type="text"
            placeholder="请输入课时数"
            v-model="form.courseHours"
          ></el-input>
        </el-form-item>

        <el-form-item required prop="courseColor" label="颜色选择">
          <el-color-picker v-model="form.courseColor"></el-color-picker>
        </el-form-item>

        <el-form-item required prop="courseTypeId" label="课程类型:">
          <el-select v-model="form.courseTypeId" placeholder="选择课程类型">
            <el-option
              v-for="item in this.coursetypeList.coursetypeList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="sort" label="排序">
          <el-input
            type="text"
            placeholder="请输入排序（数字）"
            v-model="form.sort"
          ></el-input>
        </el-form-item>

        <el-form-item class="text_right">
          <el-button @click="isVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')">提 交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { addClasstype, editClasstype } from "@/api/courseType";
import { addOperationRecord } from "@/api/operationrecord";
import { getToken } from "@/utils/auth";

export default {
  name: "addFundDialogs",
  data() {
    return {
      isVisible: this.isShow,
      form: {
        id: "",
        classType: "",
        courseTypeId: "",
        courseColor: "",
        courseHours: "",
        sort: ""
      },
      //详情弹框信息
      dialog: {
        width: "400px",
        formLabelWidth: "120px",
      },
    };
  },
  props: {
    isShow: Boolean,
    dialogRow: Object,
    coursetypeList: Object,
  },
  computed: {
    ...mapGetters(["addClassTypeDialog"]),
  },
  created() {},
  mounted() {
    if (this.addClassTypeDialog.type === "edit") {
      console.info("this.dialogRow:");
      this.form = this.dialogRow.param;
    } else {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    }
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    //表单提交
    onSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          //表单数据验证完成之后，提交数据;
          let formData = this[form];
          const para = Object.assign({}, formData);
          console.log(para);
          // edit
          if (this.addClassTypeDialog.type === "edit") {
            editClasstype(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                const para = {
                  userName: getToken("USERNAME"),
                  content: "修改(" + this.form.classType + ")班级类型操作",
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.isVisible = false;
                this.$emit("getClassTypeList");
              }
            });
          } else {
            // add
            addClasstype(para).then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.$message({
                  message: "新增成功",
                  type: "success",
                });
                const para = {
                  userName: getToken("USERNAME"),
                  content: "添加(" + this.form.classType + ")班级类型操作",
                };
                addOperationRecord(para).then((res) => {
                  console.log(res);
                });
                this.$refs["form"].resetFields();
                this.isVisible = false;
                this.$emit("getClassTypeList");
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                });
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
</style>
